<p-dialog header="{{ productInput?.title | translate }}" [(visible)]="modalViewSubscriptionPlanService.visibleModal"
    [breakpoints]="{'320px': '90vw'}" [style]="{width: '35vw'}" [modal]="true">
    <div class="main-container">
        <video class="custom-video" autoplay loop>
            <source src="{{productInput?.video}}" type="video/mp4" />
        </video>

        <p style="text-align: center; width: 90%; margin: 0px">{{productInput?.description | translate }}</p>

        <div *ngIf="productInput?.rangedPrice">
            <p-table [value]="productInput?.prices">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="align-center">Units</th>
                        <th class="align-center">Price per unit (USD)</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-price>
                    <tr>
                        <td class="align-center blue-bg">{{ price.units }}</td>
                        <td class="align-center blue-bg">{{ price.pricePerUnit }}$</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div *ngIf="!productInput?.rangedPrice">
            <p class="price">
                {{
                user?.role === "ROLE_CUSTOMER" || user?.role === "ROLE_INDIVIDUAL_CLIENT"
                ? "9 USD/ Pair"
                : "5 USD/ Pair"
                }}
            </p>
        </div>

        <button mat-raised-button color="primary" [disabled]="isLoading"
            (click)="subscribeToService(productInput.serviceName)">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isLoading ? ('SUBSCRIBING' | translate) : ('SUBSCRIBE' | translate) }}
        </button>

    </div>
</p-dialog>